/* Browser favourites enhancement. No customer identity or bearer tokens are stored here.
 * Account favourites continue to use My Moda's authenticated Customer Account API.
 * Product data/images are requested only after a customer opens this panel. */
(() => {
  'use strict';
  const dialog = document.getElementById('mip-favourites');
  const shareDialog = document.getElementById('mip-favourites-share');
  if (!dialog || !shareDialog || typeof dialog.showModal !== 'function') return;
  const shareBody = shareDialog.querySelector('[data-fav-share-body]');
  const shareMessage = shareDialog.querySelector('[data-fav-share-status]');
  const body = dialog.querySelector('[data-fav-body]');
  const message = dialog.querySelector('[data-fav-message]');
  const toast = document.querySelector('[data-fav-toast]');
  const root = dialog.dataset.root.replace(/\/?$/, '/');
  const handlesKey = 'wishlistItem';
  const choicePrefix = 'mip_favourite_choice:';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const cache = new Map();
  let current = null, trigger = null, request = 0, toastTimer;
  let returnToList = false, listMode = false, listLimit = 12;
  const cartPending = new Set(), cartUncertain = new Set();
  const listProducts = new Map();
  const shareStrings = JSON.parse(dialog.querySelector('[data-fav-share-strings]')?.textContent || '{}');
  const shareText = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`[${name}]`, String(value)), shareStrings[key] || key);
  let shareMode = false, shareSession = null, shareTrigger = null, nativeSharePending = false;
  const shareIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V3m-5 5 5-5 5 5M5 13v7h14v-7"/></svg>';
  const shareIcons = {
    whatsapp: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 11.8a8.5 8.5 0 0 1-12.6 7.4L3 20.5l1.3-4.8a8.5 8.5 0 1 1 16.2-3.9Z"/><path d="m8.2 7.5 1.4 2.6-1 1a7.2 7.2 0 0 0 4.3 4.1l1-1 2.6 1.3c.1 1.7-1.3 2.3-2.4 2-4.7-1.2-7.8-4.4-8-7.2-.1-1.4.8-2.7 2.1-2.8Z"/></svg>',
    email: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="1"/><path d="m3 6 9 7 9-7"/></svg>',
    copy: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="8" width="12" height="13" rx="1"/><path d="M16 8V3H3v13h5"/></svg>'
  };
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';

  function handles() {
    const value = JSON.parse(localStorage.getItem(handlesKey) || '[]');
    if (!Array.isArray(value) || !value.every(validHandle)) throw new Error('saved-list');
    return [...new Set(value)];
  }
  function choice(handle) {
    try {
      const value = JSON.parse(localStorage.getItem(choicePrefix + handle) || 'null');
      if (value?.version !== 1 || !value.options || typeof value.options !== 'object' || Array.isArray(value.options)) return null;
      return value;
    } catch (_) { return null; }
  }
  function say(text) {
    if (dialog.open) { message.textContent = text; return; }
    toast.textContent = text; toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 6500);
  }
  function sync(scope = document) {
    let saved;
    try { saved = handles(); } catch (_) { return; }
    const controls = [...scope.querySelectorAll('[data-wishlist]')];
    if (scope.matches?.('[data-wishlist]')) controls.push(scope);
    for (const control of controls) {
      const added = saved.includes(control.dataset.wishlistHandle);
      control.classList.toggle('wishlist-added', added);
      control.setAttribute('aria-pressed', String(added));
      control.setAttribute('aria-label', added ? 'Remove from favourites' : 'Add to favourites');
      const text = control.querySelector('.text');
      if (text) text.textContent = added ? 'Added to favourites' : 'Add to favourites';
    }
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = String(saved.length); });
    scope.querySelectorAll('[data-fav-edit]').forEach(el => {
      const selected = choice(el.dataset.favEdit);
      const labels = selected ? Object.entries(selected.options).filter(([,value]) => typeof value === 'string' && value).map(([name,value]) => `${name}: ${value}`) : [];
      el.textContent = labels.length ? `${labels.join(' · ')} — Edit` : 'Choose colour & size';
    });
  }
  function emit(name, detail = {}) { document.dispatchEvent(new CustomEvent(name, { detail, bubbles: true })); }
  function writeHandles(next) {
    localStorage.setItem(handlesKey, JSON.stringify(next));
    sync();
    emit('updatewishlistmail');
    emit('mip:favourites-changed', { handles: next });
  }
  function removeListCard(handle) {
    const container = document.querySelector('[data-wishlist-container]');
    if (!container) return;
    container.querySelectorAll('[data-product-handle]').forEach(card => { if (card.dataset.productHandle === handle) card.remove(); });
    emit('updatepagination');
    const empty = container.querySelector('[data-fav-empty]');
    const isEmpty = !handles().length;
    if (isEmpty && !empty) {
      const note = document.createElement('p'); note.dataset.favEmpty = ''; note.className = 'wishlist-content-empty text-center';
      note.textContent = 'Your favourites list is empty. Tap a heart to save a pair you love.'; container.append(note);
    } else if (!isEmpty) empty?.remove();
    const footer = document.querySelector('[data-wishlist-footer]');
    if (footer) footer.hidden = isEmpty;
  }
  function add(handle) {
    const saved = handles();
    if (saved.includes(handle)) return;
    if (saved.length >= 128) throw new Error('full');
    writeHandles([...saved, handle]);
    emit('addwishlistitem', { handle });
  }
  function remove(handle) {
    writeHandles(handles().filter(value => value !== handle));
    try { localStorage.removeItem(choicePrefix + handle); } catch (_) {}
    removeListCard(handle);
    say('Removed from your favourites on this browser.');
  }
  function imageURL(source, width) {
    if (!source) return '';
    try {
      const url = new URL(source, location.origin);
      if (url.protocol !== 'https:' || !(url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.shopify.com'))) return '';
      if (width) url.searchParams.set('width', width);
      return url.href;
    } catch (_) { return ''; }
  }
  async function product(handle) {
    const cached = cache.get(handle);
    if (cached && Date.now() - cached.time < 120000) return cached.value;
    const abort = new AbortController();
    const timeout = setTimeout(() => abort.abort(), 12000);
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}?view=mip-favourite`, { credentials: 'same-origin', signal: abort.signal });
      if (!response.ok) throw new Error('product');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const value = JSON.parse(document.querySelector('[data-mip-favourite-product]')?.textContent || 'null');
      if (value?.handle !== handle || !Array.isArray(value.variants) || !Array.isArray(value.options) || !Array.isArray(value.images)) throw new Error('product');
      cache.set(handle, { value, time: Date.now() });
      return value;
    } finally { clearTimeout(timeout); }
  }
  function initialOptions(data) {
    const saved = choice(data.handle)?.options || {};
    const selected = {};
    data.options.forEach((name,index) => {
      const available = [...new Set(data.variants.filter(v => v.available).map(v => v.options[index]))];
      // A size is never chosen implicitly, even if there is only one left.
      selected[name] = available.includes(saved[name]) ? saved[name] : !/size/i.test(name) && available.length === 1 ? available[0] : '';
    });
    // Previously selected combinations may have sold out since the last visit.
    if (!data.variants.some(v => v.available && data.options.every((name,i) => !selected[name] || v.options[i] === selected[name]))) {
      data.options.forEach(name => { selected[name] = ''; });
    }
    return selected;
  }
  function variant() {
    return current?.product.variants.find(v => v.available && current.product.options.every((name,i) => current.selected[name] && v.options[i] === current.selected[name]));
  }
  function amount(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: dialog.dataset.currency }).format(Number(value) / 100);
  }
  function heading(list, editing = false) {
    listMode = list;
    const title = dialog.querySelector('#mip-fav-title');
    if (title) title.textContent = list ? (dialog.dataset.listTitle || 'My favourites') : 'A little love for your list';
    const eyebrow = dialog.querySelector('.mip-fav__eyebrow');
    if (eyebrow) eyebrow.textContent = list ? 'The pairs you love' : 'Your next favourite';
    const back = dialog.querySelector('[data-fav-back]');
    if (back) back.hidden = !editing;
  }
  function savedVariant(data) {
    const saved = choice(data.handle);
    const exact = data.variants.find(v => v.id === saved?.variantId && v.available);
    if (exact) return exact;
    return data.variants.length === 1 && data.variants[0].title === 'Default Title' && data.variants[0].available ? data.variants[0] : null;
  }
  function listRow(handle) {
    const data = listProducts.get(handle);
    const remove = `<button type="button" class="mip-fav__remove" data-fav-remove="${escape(handle)}" aria-label="Remove ${escape(data?.title || handle)} from favourites"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14M10 10v8M14 10v8"/></svg></button>`;
    if (!data) return `<article class="mip-fav__row"><div class="mip-fav__row-copy"><h3>${escape(handle.replace(/-/g,' '))}</h3><p>We couldn’t load this pair.</p><button type="button" class="mip-fav__back" data-fav-list-retry>Try again</button></div>${remove}</article>`;
    const selected = savedVariant(data);
    const source = imageURL(selected?.image || data.images[0],280);
    const options = choice(handle)?.options || {};
    const labels = Object.entries(options).filter(([name,value]) => name !== 'Title' && typeof value === 'string' && value).map(([name,value])=>`${name}: ${value}`);
    if (data.colour && !data.options.some(name=>/colou?r/i.test(name))) labels.unshift(data.colour);
    const url = `${root}products/${handle}${selected ? '?variant='+selected.id : ''}`;
    const inStock = data.variants.some(v=>v.available);
    return `<article class="mip-fav__row" data-fav-row="${escape(handle)}"><a class="mip-fav__row-image" href="${escape(url)}">${source?`<img src="${escape(source)}" alt="${escape(data.title)}" width="124" height="170" loading="lazy">`:''}</a><div class="mip-fav__row-copy"><p class="mip-fav__row-price" data-mip-money>${escape(amount(selected?.price ?? data.price))}</p><h3><a href="${escape(url)}">${escape(data.title)}</a></h3>${labels.length?`<p class="mip-fav__row-options">${escape(labels.join(' · '))}</p>`:''}<button type="button" class="mip-fav__back" data-fav-list-edit="${escape(handle)}">${selected?'Edit colour & size':'Choose colour & size'}</button>${inStock?`<button type="button" class="mip-fav__bag" data-fav-bag="${escape(handle)}" ${cartPending.has(handle)||cartUncertain.has(handle)?'disabled':''}>${cartPending.has(handle)?'Adding…':cartUncertain.has(handle)?'Check My Bag':'Add to My Bag'}</button>`:'<p class="mip-fav__hint">Currently sold out</p>'}</div>${remove}</article>`;
  }
  function paintList() {
    const saved = handles();
    heading(true);
    body.setAttribute('aria-busy','false');
    body.innerHTML = saved.length ? `<div class="mip-fav__list-summary">${saved.length} ${saved.length===1?'favourite':'favourites'} <span>Saved on this browser</span></div><div class="mip-fav__list">${saved.slice(0,listLimit).map(listRow).join('')}</div>${saved.length>listLimit?'<button type="button" class="mip-fav__secondary mip-fav__more" data-fav-more>Show more favourites</button>':''}<div class="mip-fav__list-footer"><p class="mip-fav__share-invite">${escape(shareText('invite'))}</p><button type="button" class="mip-fav__primary mip-fav__share-cta" data-fav-share>${shareIcon}<span>${escape(shareText('cta'))}</span></button><a href="${escape(root)}cart" class="mip-fav__back">View My Bag</a></div>` : `<div class="mip-fav__empty">${heart}<h3>A little room for something lovely</h3><p>Tap the heart on a pair you love and find it here.</p><button type="button" class="mip-fav__primary" data-fav-close>Continue shopping</button></div>`;
  }
  async function loadList() {
    const serial = ++request;
    current = null; returnToList = true;
    heading(true);
    const saved = handles().slice(0,listLimit);
    body.setAttribute('aria-busy','true');
    body.innerHTML='<div class="mip-fav__loading" role="status">Loading your favourites…</div>';
    // Bound concurrency; a large saved list must not flood the storefront.
    for (let start=0; start<saved.length; start+=4) {
      await Promise.all(saved.slice(start,start+4).map(async handle=>{try{listProducts.set(handle,await product(handle));}catch(_){listProducts.delete(handle);}}));
      if (serial!==request || !dialog.open) return;
    }
    paintList();
  }
  function openList(control) {
    if (!dialog.open || !trigger) trigger=control;
    returnToList=true;listLimit=12;message.textContent='';toast.hidden=true;
    dialog.classList.add('mip-fav--drawer');
    if(!dialog.open)dialog.showModal();
    document.documentElement.classList.add('mip-fav-open');
    dialog.querySelector('[data-fav-close]').focus({preventScroll:true});
    loadList().catch(()=>{body.setAttribute('aria-busy','false');body.innerHTML='<div class="mip-fav__error">We couldn’t read your saved favourites. Please allow browser storage and try again.</div>';});
  }
  function editFromList(handle) {
    returnToList=true;heading(false,true);load(handle);
  }
  async function addToBag(handle,button) {
    if (cartPending.has(handle) || cartUncertain.has(handle)) return;
    const data=listProducts.get(handle), selected=data && savedVariant(data);
    if(!selected){editFromList(handle);say('Choose your size and save your preferences, then add this pair to My Bag.');return;}
    cartPending.add(handle);button.disabled=true;button.textContent='Adding…';
    let confirmed=false;
    const abort=new AbortController(),timeout=setTimeout(()=>abort.abort(),15000);
    try {
      const response=await fetch(`${root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:selected.id,quantity:1}]}),signal:abort.signal});
      const result=await response.json();
      if(!response.ok || !result.items?.some(item=>Number(item.id || item.variant_id)===selected.id)) throw new Error(result.description || 'unconfirmed');
      confirmed=true;
      say('Added to My Bag. Your favourite is still here for next time.');
    } catch (_) {
      // Never silently repeat an ambiguous cart write: it may already have succeeded.
      cartUncertain.add(handle);cache.delete(handle);
      say('We couldn’t confirm this addition. Please check My Bag before trying again.');
    } finally {
      clearTimeout(timeout);cartPending.delete(handle);
      if(dialog.open && listMode){paintList();const next=body.querySelector(`[data-fav-bag="${handle}"]`);(next && !next.disabled ? next : dialog.querySelector('[data-fav-close]')).focus({preventScroll:true});}
    }
    if(confirmed){
      try {
        const response=await fetch(`${root}cart.js`,{credentials:'same-origin'});if(!response.ok)return;
        const cart=await response.json();
        if(!Number.isInteger(cart.item_count))return;
        document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=String(cart.item_count);});
        document.querySelectorAll('[data-cart-text]').forEach(el=>{el.textContent=cart.item_count===1?'item':'items';});
        const cartLink=document.getElementById('cart-icon-bubble');if(cartLink)cartLink.setAttribute('aria-label',`${cart.item_count} ${cart.item_count===1?'item':'items'}`);
        emit('cart-update',cart);
      }catch(_){}
    }
  }
  function sharePayload() {
    const entries = handles().map(handle => {
      const data = listProducts.get(handle), saved = choice(handle);
      const id = Number.isSafeInteger(saved?.variantId) && saved.variantId > 0 ? saved.variantId : null;
      const options = saved?.options || {};
      const labels = Object.entries(options).filter(([name, value]) => name !== 'Title' && typeof value === 'string' && value).map(([name, value]) => `${name}: ${value}`);
      if (data?.colour && !data.options.some(name => /colou?r/i.test(name))) labels.unshift(data.colour);
      return {
        title: data?.title || handle.replace(/-/g, ' '),
        options: labels.join(' · '),
        image: imageURL(data?.images[0], 120),
        url: new URL(`${root}products/${handle}${id ? '?variant=' + id : ''}`, location.origin).href
      };
    });
    const title = shareText('message_title');
    const intro = shareText('message_intro');
    const text = [intro, ...entries.map(item => [item.title, item.options, item.url].filter(Boolean).join('\n'))].join('\n\n');
    const native = entries.length === 1 ? {title, text: [intro, entries[0].title, entries[0].options].filter(Boolean).join('\n'), url: entries[0].url} : {title, text};
    return {entries, title, text, native};
  }
  function showShare() {
    const payload = sharePayload();
    if (!payload.entries.length) { if (shareDialog.open) shareDialog.close(); paintList(); return; }
    if (!shareDialog.open) shareTrigger = body.querySelector('[data-fav-share]');
    shareMode = true;
    shareSession = payload;
    shareMessage.textContent = '';
    const count = payload.entries.length;
    const whatsapp = 'https://wa.me/?text=' + encodeURIComponent(payload.text);
    const email = 'mailto:?subject=' + encodeURIComponent(payload.title) + '&body=' + encodeURIComponent(payload.text);
    const countLabel = shareText(count === 1 ? 'count_one' : 'count_many', {count});
    const channel = (name, href, extra = '') => `<a class="mip-fav__share-option mip-fav__share-option--${name}" href="${escape(href)}" ${extra}><span class="mip-fav__share-icon">${shareIcons[name]}</span><span>${escape(shareText(name))}</span></a>`;
    const longMessage = email.length > 7500 || whatsapp.length > 7500;
    shareBody.setAttribute('aria-busy', 'false');
    shareBody.innerHTML = `<div class="mip-fav__share-panel"><p class="mip-fav__share-intro">${escape(shareText('intro'))}</p><div class="mip-fav__share-summary"><div class="mip-fav__share-thumbs">${payload.entries.slice(0, 3).filter(item => item.image).map(item => `<img src="${escape(item.image)}" alt="" width="58" height="74">`).join('')}</div><div><strong>${escape(countLabel)}</strong><p>${escape(shareText('included'))}</p></div></div><div class="mip-fav__share-options">${longMessage ? '' : channel('whatsapp', whatsapp, 'target="_blank" rel="noopener noreferrer"') + channel('email', email)}<button type="button" class="mip-fav__share-option mip-fav__share-option--copy" data-fav-copy><span class="mip-fav__share-icon">${shareIcons.copy}</span><span data-fav-copy-label>${escape(shareText('copy'))}</span></button></div>${longMessage ? `<p class="mip-fav__hint">${escape(shareText('long_list'))}</p>` : ''}<details class="mip-fav__share-preview"><summary>${escape(shareText('preview'))}</summary><label for="mip-fav-share-message">${escape(shareText('message_label'))}</label><textarea id="mip-fav-share-message" data-fav-share-message readonly rows="6" spellcheck="false">${escape(payload.text)}</textarea><p class="mip-fav__hint" data-fav-copy-help>${escape(shareText('copy_hint'))}</p></details>${typeof navigator.share === 'function' ? `<button type="button" class="mip-fav__share-native" data-fav-native>${shareIcon}<span>${escape(shareText('more'))}</span></button>` : ''}<p class="mip-fav__share-note">${escape(shareText('note'))}</p></div>`;
    shareBody.scrollTop = 0;
    if (!shareDialog.open) shareDialog.showModal();
    shareDialog.querySelector('[data-fav-share-close]').focus({preventScroll:true});
  }
  function shareActive(session) { return shareDialog.open && shareMode && shareSession === session; }
  function manualCopy(session) {
    if (!shareActive(session)) return;
    shareBody.querySelector('.mip-fav__share-preview').open = true;
    const field = shareBody.querySelector('[data-fav-share-message]');
    shareBody.querySelector('[data-fav-copy-help]').textContent = shareText('manual_copy');
    field.focus(); field.select(); field.setSelectionRange(0, field.value.length);
    shareMessage.textContent = shareText('manual_copy');
  }
  async function copyShare(button) {
    const session = shareSession;
    if (!session || button.disabled) return;
    button.disabled = true; shareMessage.textContent = '';
    try {
      if (!navigator.clipboard?.writeText) { manualCopy(session); return; }
      await navigator.clipboard.writeText(session.text);
      if (!shareActive(session)) return;
      button.querySelector('[data-fav-copy-label]').textContent = shareText('copied');
      shareMessage.textContent = shareText('copy_success');
    } catch (_) { manualCopy(session); }
    finally { if (button.isConnected) button.disabled = false; }
  }
  async function nativeShare(button) {
    const session = shareSession;
    if (!session || nativeSharePending || typeof navigator.share !== 'function') return;
    nativeSharePending = true; button.disabled = true; shareMessage.textContent = '';
    try {
      await navigator.share(session.native);
    } catch (error) {
      if (shareActive(session) && !['AbortError', 'InvalidStateError'].includes(error.name)) shareMessage.textContent = shareText('native_fallback');
    } finally {
      nativeSharePending = false;
      if (button.isConnected) button.disabled = false;
    }
  }
  function optionMarkup(data) {
    return data.options.map((name,index) => {
      const values = [...new Set(data.variants.map(v => v.options[index]))];
      if (name === 'Title' && values.length === 1 && values[0] === 'Default Title') return '';
      const selected = current.selected[name];
      return `<fieldset><legend>${escape(name)} <span>${/size/i.test(name) ? 'Optional' : escape(selected || 'Choose your favourite')}</span></legend><div class="${/size/i.test(name) ? 'mip-size-grid' : 'mip-fav__choices'}">${values.map(value => {
        // Changing colour may reset size; changing size must match other options.
        const available = data.variants.some(v => v.available && v.options[index] === value && data.options.every((other,i) => i === index || !current.selected[other] || (!/size/i.test(name) && /size/i.test(other)) || v.options[i] === current.selected[other]));
        const swatchVariant = /colou?r/i.test(name) ? data.variants.find(v => v.options[index] === value && v.image) : null;
        const image = imageURL(swatchVariant?.image, 80);
        return `<button type="button" class="mip-fav__option${/size/i.test(name) ? ' mip-size-tile' : ''}" data-fav-option="${index}" data-value="${escape(value)}" aria-pressed="${selected === value}" ${available ? '' : 'disabled'}>${image ? `<img src="${escape(image)}" width="28" height="28" alt="">` : ''}${/size/i.test(name) && window.ModaShoeSizes ? window.ModaShoeSizes.label(value) : escape(value)}</button>`;
      }).join('')}</div>${/size/i.test(name) ? `<p class="mip-fav__hint">${values.some(v => /[A-Za-z]/.test(v)) ? 'Sizes are shown as listed for this product.' : 'Sizes are shown as listed on the product page.'} Unavailable sizes are crossed out.</p>${selected ? `<button type="button" class="mip-fav__clear" data-fav-clear="${index}">Save without a size</button>` : ''}` : ''}</fieldset>`;
    }).join('');
  }
  function render() {
    if (!current) return;
    const data = current.product;
    const chosen = variant();
    const availableImages = data.images.map(src => imageURL(src, 700)).filter(Boolean);
    const chosenImage = imageURL(chosen?.image, 700);
    if (chosenImage) {
      const existing = availableImages.indexOf(chosenImage);
      if (existing >= 0) availableImages.splice(existing,1);
      availableImages.unshift(chosenImage);
    }
    const colours = (data.siblings || []).filter(sibling => validHandle(sibling.handle));
    if (colours.length && !colours.some(s => s.handle === data.handle)) colours.unshift({handle:data.handle,label:data.colour || data.title,image:data.images[0]});
    const isSaved = handles().includes(data.handle);
    body.innerHTML = `<div class="mip-fav__layout"><div class="mip-fav__gallery"><div class="mip-fav__images" aria-label="Product photographs" tabindex="0">${availableImages.map((src,i) => `<img src="${escape(src)}" alt="${escape(data.title)} — view ${i+1}" width="420" height="320" ${i ? 'loading="lazy"' : ''}>`).join('')}</div><div class="mip-fav__thumbs">${availableImages.map((src,i) => `<button type="button" class="mip-fav__thumb" data-fav-image="${i}" aria-label="Show product image ${i+1}" aria-pressed="${i===0}"><img src="${escape(imageURL(src,100))}" width="46" height="48" alt="" loading="lazy"></button>`).join('')}</div></div><div class="mip-fav__details"><p class="mip-fav__saved">${heart}${isSaved ? 'Saved to this browser’s favourites' : 'Ready to save your new colour'}</p><h3 class="mip-fav__name">${escape(data.title)}</h3><p class="mip-fav__price" data-mip-money>${escape(amount(chosen?.price ?? data.price))}</p><p class="mip-fav__intro">One to come back to. Add your preferred colour and size, or keep browsing — your favourite is already saved.</p>${colours.length > 1 ? `<fieldset><legend>Colour <span>${escape(data.colour)}</span></legend><div class="mip-fav__choices">${colours.map(s => `<button type="button" class="mip-fav__option" data-fav-colour="${escape(s.handle)}" aria-pressed="${s.handle===data.handle}">${imageURL(s.image,80) ? `<img src="${escape(imageURL(s.image,80))}" width="28" height="28" alt="">` : ''}${escape(s.label)}</button>`).join('')}</div></fieldset>` : data.colour ? `<p class="mip-fav__hint">Colour: ${escape(data.colour)}</p>` : ''}<div data-fav-options>${optionMarkup(data)}</div>${data.variants.some(v => v.available) ? '' : '<p class="mip-fav__hint">This pair is currently sold out. You can still keep it in your favourites.</p>'}<div class="mip-fav__actions"><button type="button" class="mip-fav__primary" data-fav-save>Save my preferences</button><a class="mip-fav__secondary" href="${escape(dialog.dataset.wishlistUrl)}">View my favourites</a><button type="button" class="mip-fav__continue" data-fav-close>Continue shopping</button></div><p class="mip-fav__account">These choices are saved on this browser. My Moda manages your account favourites.</p></div></div>`;
    body.setAttribute('aria-busy', 'false');
    const gallery = body.querySelector('.mip-fav__images');
    gallery.addEventListener('scroll', () => {
      const images = [...gallery.children];
      const nearest = images.reduce((best,img,i) => Math.abs(img.offsetLeft - images[0].offsetLeft - gallery.scrollLeft) < Math.abs(images[best].offsetLeft - images[0].offsetLeft - gallery.scrollLeft) ? i : best,0);
      body.querySelectorAll('[data-fav-image]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.favImage) === nearest)));
    }, { passive:true });
  }
  async function load(handle, original = handle) {
    const serial = ++request;
    heading(false,returnToList);
    message.textContent = '';
    body.setAttribute('aria-busy','true');
    body.innerHTML = '<div class="mip-fav__loading" role="status">Loading your favourite…</div>';
    try {
      const data = await product(handle);
      if (serial !== request || !dialog.open) return;
      current = { product:data, original, selected:initialOptions(data) };
      render();
      if(!dialog.contains(document.activeElement))dialog.querySelector('[data-fav-close]').focus({preventScroll:true});
    } catch (_) {
      if (serial !== request || !dialog.open) return;
      body.setAttribute('aria-busy','false');
      body.innerHTML = `<div class="mip-fav__error"><p>Your favourite is saved. We couldn’t load its choices just now.</p><button type="button" class="mip-fav__secondary" data-fav-retry="${escape(handle)}" data-original="${escape(original)}">Try again</button><p><a href="${escape(dialog.dataset.wishlistUrl)}">View my favourites</a></p></div>`;
    }
  }
  function open(handle, control) {
    trigger = control; current = null;
    returnToList=false;dialog.classList.remove('mip-fav--drawer');heading(false);
    toast.hidden = true;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('mip-fav-open');
    dialog.querySelector('[data-fav-close]').focus({preventScroll:true});
    load(handle);
  }
  function save() {
    if (!current) return;
    const data = current.product;
    let saved = handles();
    // Do not resurrect a favourite removed in another tab while the panel was open.
    if (!saved.includes(current.original)) throw new Error('removed');
    const selected = variant();
    const value = { version:1, options:current.selected, variantId:selected?.id || null };
    const previous = localStorage.getItem(choicePrefix + data.handle);
    localStorage.setItem(choicePrefix + data.handle, JSON.stringify(value));
    const newColour = data.handle !== current.original;
    try {
      saved = [...new Set(saved.map(handle => handle === current.original ? data.handle : handle))];
      writeHandles(saved);
    } catch (error) {
      try { if (previous === null) localStorage.removeItem(choicePrefix + data.handle); else localStorage.setItem(choicePrefix + data.handle, previous); } catch (_) {}
      throw error;
    }
    if (newColour) {
      removeListCard(current.original);
      if (!document.querySelector(`[data-product-handle="${data.handle}"]`)) emit('addwishlistitem', { handle:data.handle });
      current.original = data.handle;
    }
    if(returnToList){listProducts.set(data.handle,data);paintList();}
    else render();
    say('Your preferences are saved on this browser. A little something to look forward to.');
    (body.querySelector(`[data-fav-bag="${data.handle}"]`) || body.querySelector('[data-fav-save]'))?.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const link=event.target.closest('a[href]');
    if(link && !link.hasAttribute('data-fav-fallback') && !window.ModaFavouritesEntry && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button===0){
      const destination=new URL(link.href,location.origin), wishlist=new URL(dialog.dataset.wishlistUrl,location.origin);
      if(destination.origin===location.origin && destination.pathname===wishlist.pathname){event.preventDefault();event.stopImmediatePropagation();openList(link);return;}
    }
    const control = event.target.closest('[data-wishlist], [data-fav-edit]');
    if (!control || control.closest('#mip-favourites')) return;
    const handle = control.dataset.wishlistHandle || control.dataset.favEdit;
    if (!validHandle(handle)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    try {
      if (control.hasAttribute('data-fav-edit')) { if (handles().includes(handle)) open(handle,control); else say('Save this pair to your browser favourites before choosing a size.'); }
      else if (handles().includes(handle)) remove(handle);
      else { add(handle); open(handle,control); }
    } catch (error) { say(error.message === 'full' ? 'Your list has 128 favourites. Remove a pair before adding another.' : 'We couldn’t update your favourites. Please allow browser storage and try again.'); }
  }, true);
  dialog.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (event.target === dialog) { const rect=dialog.getBoundingClientRect(); if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) dialog.close(); return; }
    if (!button) return;
    try {
      if (button.hasAttribute('data-fav-close')) dialog.close();
      else if (button.hasAttribute('data-fav-back')) { message.textContent=''; loadList().then(()=>{if(dialog.open && listMode)body.querySelector('[data-fav-share]')?.focus({preventScroll:true});}).catch(()=>say('We couldn’t load your favourites. Please try again.')); }
      else if (button.hasAttribute('data-fav-list-retry')) loadList().catch(()=>say('We couldn’t load your favourites. Please try again.'));
      else if (button.hasAttribute('data-fav-more')) {listLimit+=12;loadList().catch(()=>say('We couldn’t load more favourites. Please try again.'));}
      else if (button.dataset.favListEdit) editFromList(button.dataset.favListEdit);
      else if (button.dataset.favRemove) {const handle=button.dataset.favRemove;remove(handle);paintList();(body.querySelector('[data-fav-remove]') || dialog.querySelector('[data-fav-close]')).focus({preventScroll:true});}
      else if (button.dataset.favBag) addToBag(button.dataset.favBag,button).catch(()=>say('Please check My Bag before trying again.'));
      else if (button.hasAttribute('data-fav-share')) showShare();
      else if (button.hasAttribute('data-fav-save')) save();
      else if (button.dataset.favRetry) load(button.dataset.favRetry,button.dataset.original);
      else if (button.dataset.favColour && current) load(button.dataset.favColour,current.original);
      else if (button.dataset.favImage !== undefined) {
        const gallery=body.querySelector('.mip-fav__images'); const image=gallery.children[Number(button.dataset.favImage)];
        gallery.scrollTo({left:image.offsetLeft-gallery.children[0].offsetLeft,behavior:'instant'});
      } else if (current && (button.dataset.favOption !== undefined || button.dataset.favClear !== undefined)) {
        const index=Number(button.dataset.favOption ?? button.dataset.favClear), name=current.product.options[index];
        current.selected[name]=button.dataset.favClear !== undefined ? '' : button.dataset.value;
        if (!/size/i.test(name)) current.product.options.filter(name=>/size/i.test(name)).forEach(name=>{ current.selected[name]=''; });
        const value=button.dataset.value;
        render();
        const replacement=[...body.querySelectorAll('[data-fav-option]')].find(el=>Number(el.dataset.favOption)===index && el.dataset.value===value) || body.querySelector('[data-fav-save]');
        replacement.focus({preventScroll:true});
      }
    } catch (error) { say(error.message === 'removed' ? 'This favourite was removed in another tab. Close this panel and tap its heart to save it again.' : 'We couldn’t save these choices. Your existing favourites have been kept. Please try again.'); }
  });
  shareDialog.addEventListener('click', event => {
    if (event.target === shareDialog) {
      const rect = shareDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) shareDialog.close();
      return;
    }
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-fav-share-close')) shareDialog.close();
    else if (button.hasAttribute('data-fav-copy')) copyShare(button);
    else if (button.hasAttribute('data-fav-native')) nativeShare(button);
  });
  shareDialog.addEventListener('close', () => {
    if (shareDialog.open) return;
    shareMode = false; shareSession = null; shareMessage.textContent = '';
    shareBody.replaceChildren();
    if (dialog.open) (shareTrigger?.isConnected ? shareTrigger : body.querySelector('[data-fav-share]') || dialog.querySelector('[data-fav-close]')).focus({preventScroll:true});
  });
  dialog.addEventListener('close', () => {
    if (shareDialog.open) shareDialog.close();
    request++; current=null; listMode=false; returnToList=false; shareMode=false; shareSession=null; document.documentElement.classList.remove('mip-fav-open');
    if (trigger?.isConnected) trigger.focus({preventScroll:true});
  });
  window.addEventListener('storage', event => { if(event.key===handlesKey || event.key?.startsWith(choicePrefix)){sync();if(dialog.open && shareMode){paintList();showShare();return;}if(dialog.open && listMode)loadList().catch(()=>say('Please reopen your favourites to refresh this list.'));} });
  window.addEventListener('pageshow', () => sync());
  // Existing Ajax cards call setProductForWishlist; this event also covers wishlist-page edits.
  document.addEventListener('mip:favourite-card-ready', event => sync(event.target));
  window.ModaFavourites = Object.freeze({ choice, sync });
  window.ModaFavouritesEntry?.ready(openList);
  document.addEventListener('DOMContentLoaded', () => sync(), {once:true});
  sync();
})();
